import { KoreanContainer, KoreanItem } from '../../styles/onBoardStyle';
import Checkbox from './checkbox';

interface THProps {
	isFirstChecked: boolean;
	checkFirst: Function
}

const ThPP = (props: THProps) => {
	return (
		<KoreanContainer style={{ padding: '0px 0px 24px' }}>
			<KoreanItem style={{ marginLeft: 'initial' }}>
				<label>
					เดอะ คลีนิกข์ คลินิคอล เรียลิตี้ แอป (The Clinique Clinical Reality App) จะวิเคราะห์ภาพใบหน้าของท่าน และนำเสนอโซลูชันสำหรับการบำรุงผิวที่เฉพาะเจาะจงสำหรับท่าน และให้คำแนะนำเกี่ยวกับผลิตภัณฑ์ที่เกี่ยวข้อง ภาพของท่านจะถูกจัดเก็บ และประมวลผลภายในแอปนี้เป็นระยะเวลาเท่าที่ท่านได้ใช้งานในปัจจุบัน และจะถูกลบทิ้งทันที
				</label>
			</KoreanItem>

			<KoreanItem>
				<Checkbox checked={props.isFirstChecked} onChange={() => props.checkFirst(!props.isFirstChecked)} disabled={false} />
				<label>ท่านยืนยันว่าท่านเป็นผู้บรรลุนิติภาวะ และยินยอมให้คลีนิกข์ใช้ภาพใบหน้าของท่านเพื่อวัตถุประสงค์นี้ และท่านได้ตกลงยอมรับน <a style={{ textDecoration: 'underline' }} target={'_blank'} rel='noreferrer' href='https://www.clinique.co.th/customer-care/general-info/privacy-policy'>โยบายความเป็นส่วนตัวของเรา</a>
				</label>
			</KoreanItem>

			<KoreanItem>
				<label>โดยการถ่ายภาพ หรืออัปโหลดภาพของท่าน ท่านยืนยันว่าท่านเป็นผู้บรรลุนิติภาวะ และยินยอมให้คลีนิกข์ใช้ภาพใบหน้าของท่านเพื่อวัตถุประสงค์นี้ และท่านได้ตกลงยอมรับน <a style={{ textDecoration: 'underline' }} target={'_blank'} rel='noreferrer' href='https://www.clinique.co.th/customer-care/general-info/privacy-policy'>โยบายความเป็นส่วนตัวของเรา</a></label>
			</KoreanItem>
		</KoreanContainer>
	);
};

export default ThPP;